module.exports = __webpack_public_path__ + "img/无数据插画.f66ba651.png";